/**
 * Creates a comparator function for sorting objects by a string property.
 * Handles null/undefined values safely by treating them as empty strings.
 *
 * @param {string} prop - The property name to sort by
 * @returns {function} A comparator function for use with Array.sort()
 *
 * @example
 * const articles = [{ title: 'Beta' }, { title: null }, { title: 'Alpha' }];
 * articles.sort(compareByProperty('title'));
 * // Result: [{ title: null }, { title: 'Alpha' }, { title: 'Beta' }]
 */
export const compareByProperty = prop => (a, b) => (a[prop] || '').localeCompare(b[prop] || '');

export default { compareByProperty };
